import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyOutlined, DeleteOutlined, RightOutlined, ScanOutlined } from "@ant-design/icons";
import { Layout, Progress, Spin } from "antd";
import { isFlowCancellationError } from "mobx";
import { observer } from "mobx-react";
import { Fragment, useCallback, useState } from "react";
import { AnalyseFooter } from "./analyseFooter.js";
import { AnalyseItems } from "./analyseItems.js";
import { AnalyseResult } from "./analyseResult.js";
import { ProFooter, ProTag } from "./proFooter.js";
import { useStores } from "../store/stores.js";
import { __, _n } from "../utils/i18n.js";
const { Header, Content } = Layout;
const AnalyseContent = observer(({ onClick })=>{
    const [analyzePromise, setAnalyzePromise] = useState(null);
    const { statsStore, attachmentsStore, optionStore } = useStores();
    const { imagesCount, deletableSpace, deletableSpaceFormat, totalCount, newThumbnailsCount } = statsStore;
    const { analyzeBusy, analyzed } = attachmentsStore;
    const { others: { showProHints, isPro } } = optionStore;
    const handleStart = useCallback(()=>{
        const start = attachmentsStore.analyze();
        start.catch((e)=>{
            if (isFlowCancellationError(e)) {
            // Silence is golden.
            }
        });
        setAnalyzePromise(start);
    }, [
        attachmentsStore,
        optionStore,
        setAnalyzePromise
    ]);
    const handleClear = useCallback(()=>{
        const clear = attachmentsStore.clear();
        clear.catch((e)=>{
            if (isFlowCancellationError(e)) {
            // Silence is golden.
            }
        });
        setAnalyzePromise(clear);
    }, [
        attachmentsStore,
        setAnalyzePromise
    ]);
    return /*#__PURE__*/ _jsxs(Layout, {
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                style: {
                    background: "#fff"
                },
                children: [
                    __("Thumbnails"),
                    " ",
                    /*#__PURE__*/ _jsx(RightOutlined, {}),
                    " ",
                    __("Analyze")
                ]
            }),
            /*#__PURE__*/ _jsx(Content, {
                style: {
                    margin: "24px 16px 0"
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "rtg-dialog-content",
                    children: [
                        !isPro && showProHints && /*#__PURE__*/ _jsx(ProFooter, {}),
                        /*#__PURE__*/ _jsxs(Spin, {
                            spinning: statsStore.busy,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: analyzeBusy ? /*#__PURE__*/ _jsx("button", {
                                        className: "button",
                                        onClick: analyzePromise.cancel,
                                        children: __("Cancel (%d of %d analyzed)", analyzed.length, imagesCount)
                                    }) : /*#__PURE__*/ _jsxs(Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                className: "button-primary",
                                                onClick: handleStart,
                                                children: __("Analyze all attachments")
                                            }, "1"),
                                            (showProHints || isPro) && /*#__PURE__*/ _jsxs(Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        className: "button",
                                                        disabled: deletableSpace <= 0 || !isPro,
                                                        style: {
                                                            marginLeft: 10
                                                        },
                                                        onClick: handleClear,
                                                        children: __("Delete unused thumbnails")
                                                    }, "2"),
                                                    "\xa0",
                                                    /*#__PURE__*/ _jsx(ProTag, {
                                                        feature: "delete-unused-mass"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(AnalyseResult, {
                                    legend: /*#__PURE__*/ _jsx(CopyOutlined, {}),
                                    style: {
                                        display: "inline-block",
                                        marginRight: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("li", {
                                            children: _n("%d image", "%d images", imagesCount, imagesCount)
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: _n("%d image incl. thumbnails", "%d images incl. thumbnails", totalCount, totalCount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(AnalyseResult, {
                                    legend: /*#__PURE__*/ _jsx(ScanOutlined, {}),
                                    style: {
                                        display: "inline-block",
                                        marginRight: 10
                                    },
                                    children: /*#__PURE__*/ _jsx("li", {
                                        children: _n("%d thumbnail needs to be generated", "%d thumbnails need to be generated", newThumbnailsCount, newThumbnailsCount)
                                    })
                                }),
                                /*#__PURE__*/ _jsx(AnalyseResult, {
                                    legend: /*#__PURE__*/ _jsx(DeleteOutlined, {}),
                                    style: {
                                        display: "inline-block",
                                        marginRight: 10
                                    },
                                    children: /*#__PURE__*/ _jsx("li", {
                                        children: __("%s unused", deletableSpaceFormat)
                                    })
                                })
                            ]
                        }),
                        (analyzeBusy || analyzed.length > 0) && /*#__PURE__*/ _jsx(Progress, {
                            percent: Math.round(analyzed.length / imagesCount * 100),
                            status: analyzeBusy ? "active" : "success"
                        }),
                        /*#__PURE__*/ _jsx(AnalyseItems, {
                            attachments: "analyzedObjects",
                            onClick: onClick,
                            fallback: /*#__PURE__*/ _jsx("div", {
                                className: "rtg-grow",
                                style: {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ _jsx("button", {
                                    className: "button-primary",
                                    onClick: handleStart,
                                    children: __("Start the analysis to see the results for all your uploads")
                                })
                            }),
                            buttonRight: /*#__PURE__*/ _jsxs("button", {
                                className: "button-primary",
                                onClick: ()=>document.querySelector(`li[data-id="rtg-dialog-menu-item-regenerate"]`).click(),
                                children: [
                                    /*#__PURE__*/ _jsx(ScanOutlined, {}),
                                    " ",
                                    __("Start regenerating")
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(AnalyseFooter, {})
        ]
    });
});
export { AnalyseContent };
